import React, { useEffect, useRef } from 'react';
import videoSrc from './fuckery_as_fuck__2.mp4';

const VideoBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const video = document.createElement('video');
    video.src = videoSrc;
    video.muted = true;
    video.loop = true;
    video.setAttribute('playsinline', '');
    video.load();

    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    const drawVideo = () => {
      if (!video.paused && !video.ended) {
        const videoAspectRatio = video.videoWidth / video.videoHeight;
        const canvasAspectRatio = canvas.width / canvas.height;
        let drawWidth, drawHeight, drawX, drawY;

        if (canvasAspectRatio > videoAspectRatio) {
          drawWidth = canvas.width;
          drawHeight = drawWidth / videoAspectRatio;
          drawX = 0;
          drawY = (canvas.height - drawHeight) / 2;
        } else {
          drawHeight = canvas.height;
          drawWidth = drawHeight * videoAspectRatio;
          drawY = 0;
          drawX = (canvas.width - drawWidth) / 2;
        }

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(video, drawX, drawY, drawWidth, drawHeight);
        requestAnimationFrame(drawVideo);
      }
    };

    video.addEventListener('loadeddata', () => {
      resizeCanvas();
      video.play().then(drawVideo).catch(error => console.error("Error trying to autoplay video: ", error));
    });

    window.addEventListener('resize', resizeCanvas);

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      video.pause();
    };
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
      <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)' // Darker overlay for a pseudo-blur effect
      }}></div>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'rgba(255,255,255,.5)',
        textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '10vw',
          // fontSize: '4em',
          fontWeight: 'bold',
          letterSpacing: '0.1em',
          marginBottom: '0.5vw', 
          lineHeight: '0.9'
        }}>
          ZORANINE
        </div>
        <div style={{
          fontSize: '3vw',
          // fontSize: '1.5em',
          marginTop: '0.5vw', 
          lineHeight: '1.1'
        }}>
          ATMOSPHERIC SYNTHESIS, GLITCHIES, & FVCKERY
        </div>
      </div>
    </div>
  );
};

export default VideoBackground;
